import React, { useRef, useEffect } from 'react';
import { Tooltip } from "antd";

const LetterToolbar = ({ letters, selectedLetter, handleLetterClick }) => {
    const buttonRefs = useRef(new Map());

    // Whenever selectedLetter changes, move focus to the newly selected button
    useEffect(() => {
        const idx =
            selectedLetter === 'SYMBOLS'
                ? letters.length
                : letters.indexOf(selectedLetter);
        const btn = buttonRefs.current.get(selectedLetter);
        if (btn) btn.focus();
    }, [selectedLetter, letters]);

    const onKeyDown = (e, idx) => {
        let newIdx;
        switch (e.key) {
            case 'ArrowRight':
                newIdx = (idx + 1) % (letters.length + 1);
                break;
            case 'ArrowLeft':
                newIdx = (idx - 1 + letters.length + 1) % (letters.length + 1);
                break;
            case 'Home':
                newIdx = 0;
                break;
            case 'End':
                newIdx = letters.length;
                break;
            default:
                return;
        }
        e.preventDefault();
        const targetLetter = newIdx === letters.length ? 'SYMBOLS' : letters[newIdx];
        handleLetterClick(targetLetter);
    };

    return (
        <nav aria-label="Dictionary letter navigation">
            <div
                role="toolbar"
                aria-label="Letters A–Z"
                className="ch-letter-toolbar"
            >
                {letters.map((letter, idx) => (
                    <button
                        key={letter}
                        ref={(el) => buttonRefs.current.set(letter, el)}
                        type="button"
                        className={`ch-button-character ch-nav-item ${
                            selectedLetter === letter ? 'ch-active' : ''
                        }`}
                        onClick={() => handleLetterClick(letter)}
                        onKeyDown={(e) => onKeyDown(e, idx)}
                        tabIndex={selectedLetter === letter ? 0 : -1}
                    >
                        {letter}
                    </button>
                ))}

                <Tooltip title="Symbols">
                    <button
                        key="SYMBOLS"
                        ref={(el) => buttonRefs.current.set('SYMBOLS', el)}
                        role="button"
                        type="button"
                        className={`ch-button-character ch-nav-item ${
                            selectedLetter === 'SYMBOLS' ? 'ch-active' : ''
                        }`}
                        onClick={() => handleLetterClick('SYMBOLS')}
                        onKeyDown={(e) => onKeyDown(e, letters.length)}
                        tabIndex={selectedLetter === 'SYMBOLS' ? 0 : -1}
                        aria-label="Symbols"
                    >
                        Σ
                    </button>
                </Tooltip>
            </div>
        </nav>
    );
}

export default LetterToolbar;